import { Stack, Container } from '@chakra-ui/react';
import { FC } from 'react';

import { Section } from '@/components/ui/core/Section/Section';
import { TeamGroupData } from '@/components/ui/features/team/data';

import { TeamGroup, TeamGroupFallback } from '../TeamGroup/TeamGroup';

export const TeamContainer: FC = () => {
  return (
    <Section pt="80px">
      <Container>
        <Stack gap={14} pb="56px">
          {!Object.values(TeamGroupData).length && <TeamGroupFallback />}
          {Object.values(TeamGroupData).map((group) => (
            <TeamGroup group={group} key={group} />
          ))}
        </Stack>
      </Container>
    </Section>
  );
};
